<div class="legend-container">
  <div class="col-5 col-sm-4 col-md-3 col-lg-2 float-start">
  </div>
  <div class="col-4 col-sm-3 col-md-3 col-lg-2 float-start">
  </div>
  <div class="col-11 col-sm-11 col-md-11 col-lg-7 float-start">
    <ng-container *ngTemplateOutlet="legendColors; context: { showPeriodsatt: true }"></ng-container>
  </div>
</div>

<ng-template #legendColors let-showPeriodsatt="showPeriodsatt">
  <div class="col-4 col-sm-4 col-md-2 col-lg-2 offset-lg-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black">Planerat</label>
      <div>
        <i class="fas fa-lg fa-square volym mal" aria-hidden="true"
          container="body"
          ngbPopover="Periodens summerade kundorderplanerade volymer"
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
  <div class="col-4 col-sm-4 col-md-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black">Transporterat</label>
      <div>
        <i class="fas fa-lg fa-square volym transporterad" aria-hidden="true"
          container="body"
          ngbPopover="Periodens summerade transporterade volymer"
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
  @if (showPeriodsatt) {
    <div class="col-4 col-sm-4 col-md-2">
      <fieldset class="form-group">
        <label class="col-form-label font-color-black">Väglager</label>
        <div>
          <i class="fas fa-lg fa-square volym vaglager" aria-hidden="true"
            container="body"
            ngbPopover="Destineringsandel av aktuellt väglager"
          triggers="mouseenter:mouseleave"></i>
        </div>
      </fieldset>
    </div>
  }
</ng-template>
